import { BrandListItem } from '../../../integrated-client/models/';

export type BrandsList = Array<BrandListItem>;

export class ResultsData {

  items: BrandsList
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}